/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { AxiosInstance, AxiosRequestConfig } from 'axios';

import { ApiClient } from '../../types/api/ApiClient';
import { ApiClientResponse } from '../../types/api/ApiClientResponse';

export const apiClientFactory = (instance: AxiosInstance): ApiClient => {
  const request = <T = any, R = ApiClientResponse<T>>(config: AxiosRequestConfig) => {
    return instance.request<T, R>(config);
  };

  const getUri = (config: AxiosRequestConfig) => instance.getUri(config);

  const get = <T = any, R = ApiClientResponse<T>>(url: string, config: AxiosRequestConfig = {}) => {
    return request<T, R>({
      ...config,
      url,
      method: 'get',
    });
  };

  const post = <T = any, R = ApiClientResponse<T>>(url: string, data: object, config: AxiosRequestConfig = {}) => {
    return request<T, R>({
      ...config,
      url,
      method: 'post',
      data,
    });
  };

  const patch = <T = any, R = ApiClientResponse<T>>(url: string, data: object, config: AxiosRequestConfig = {}) => {
    return request<T, R>({
      ...config,
      url,
      method: 'patch',
      data,
    });
  };

  const put = <T = any, R = ApiClientResponse<T>>(url: string, data: object, config: AxiosRequestConfig = {}) => {
    return request<T, R>({
      ...config,
      url,
      method: 'put',
      data,
    });
  };

  const del = <T = any, R = ApiClientResponse<T>>(url: string, config: AxiosRequestConfig = {}) => {
    return request<T, R>({
      ...config,
      url,
      method: 'delete',
    });
  };

  return {
    request,
    get,
    getUri,
    post,
    patch,
    put,
    del,
    instance,
  };
};
